import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.org');
import { OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-org',
template: templateSource || '',
    styles: [``],
})
export class PortalAdminOrgComponent implements OnInit, OnChanges, OnDestroy {
    constructor(@Inject( Service) public service: Service) { }

    // 외부에서 전달받는 기관 ID (비어있으면 목록, 있으면 편집)
    @Input() orgId: string = '';

    // ─── 목록 모드 상태 ───
    public orgRows: any[] = [];
    public orgTotal: number = 0;
    public orgSearchText: string = '';
    public orgSearchField: string = 'org_kor';
    public orgPage: number = 1;
    public orgDump: number = 10;
    public orgPages: number = 1;

    // 정렬
    public sortColumn: string = 'updated';
    public sortOrder: string = 'DESC';

    // 선택 삭제
    public selectedOrgs: Set<string> = new Set();
    public deleting: boolean = false;

    // 검색 필드 옵션
    public searchFieldOptions = [
        { value: 'org_kor', label: '기관명(국문)' },
        { value: 'org_eng', label: '기관명(영문)' },
        { value: 'org_id', label: 'ORG_ID' },
        { value: 'cntry', label: '국가' },
        { value: 'industry_nm', label: '산업분류' },
        { value: 'addr_kor', label: '주소(국문)' },
        { value: 'location_nm', label: '지역' },
    ];

    // ─── 편집 모드 상태 ───
    public orgEdit: any = null;
    public orgSaving: boolean = false;
    public orgSaveError: string = '';
    public orgSaveSuccess: boolean = false;
    public editLoading: boolean = false;
    public listLoading: boolean = false;

    private successTimer: any = null;

    public async ngOnInit() {
        await this.service.init();
        if (this.orgId) {
            await this.loadOrgDetail(this.orgId);
        } else {
            await this.loadOrgList(1);
        }
        await this.service.render();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['orgId'] && !changes['orgId'].firstChange) {
            const newId = changes['orgId'].currentValue || '';
            if (newId) {
                await this.loadOrgDetail(newId);
            } else {
                await this.loadOrgList(1);
            }
            await this.service.render();
        }
    }

    public ngOnDestroy() {
        if (this.successTimer) clearTimeout(this.successTimer);
    }

    private apiUrl(fn: string) {
        return `/wiz/api/page.admin/${fn}`;
    }

    private async postForm(fn: string, params: Record<string, any>) {
        const body = new URLSearchParams();
        Object.entries(params || {}).forEach(([k, v]) => body.set(k, String(v ?? '')));
        const resp = await fetch(this.apiUrl(fn), {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            credentials: 'include',
            body: body.toString(),
        });
        return await resp.json();
    }

    // ═══════════════════════════════════════════════════════
    // 목록 모드
    // ═══════════════════════════════════════════════════════
    public async loadOrgList(page: number = 1) {
        this.orgPage = page;
        this.selectedOrgs.clear();
        this.listLoading = true;
        await this.service.render();
        try {
            const json = await this.postForm('org_list', {
                text: this.orgSearchText,
                field: this.orgSearchField,
                page: this.orgPage,
                dump: this.orgDump,
                orderby: this.sortColumn,
                order: this.sortOrder,
            });
            if (json.code === 200) {
                this.orgRows = json?.data?.rows || [];
                this.orgTotal = json?.data?.total || 0;
            } else {
                this.orgRows = [];
                this.orgTotal = 0;
            }
        } catch (e) {
            this.orgRows = [];
            this.orgTotal = 0;
        }
        this.orgPages = Math.max(1, Math.ceil((this.orgTotal || 0) / this.orgDump));
        if (this.orgPage > this.orgPages) this.orgPage = this.orgPages;
        this.listLoading = false;
        await this.service.render();
    }

    public async onSearchKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            await this.loadOrgList(1);
        }
    }

    public async toggleSort(column: string) {
        if (this.sortColumn === column) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortColumn = column;
            this.sortOrder = column === 'updated' ? 'DESC' : 'ASC';
        }
        await this.loadOrgList(1);
    }

    public sortIcon(column: string): string {
        if (this.sortColumn !== column) return 'none';
        return this.sortOrder === 'ASC' ? 'asc' : 'desc';
    }

    // 페이지네이션: << < [1..10] > >>
    public goToPage(page: number) {
        if (page < 1 || page > this.orgPages) return;
        this.loadOrgList(page);
    }

    public goFirst() { this.goToPage(1); }
    public goPrev() { this.goToPage(this.orgPage - 1); }
    public goNext() { this.goToPage(this.orgPage + 1); }
    public goLast() { this.goToPage(this.orgPages); }

    public get pageNumbers(): number[] {
        const total = this.orgPages;
        const current = this.orgPage;
        const blockSize = 10;
        const blockStart = Math.floor((current - 1) / blockSize) * blockSize + 1;
        const blockEnd = Math.min(blockStart + blockSize - 1, total);
        const pages: number[] = [];
        for (let i = blockStart; i <= blockEnd; i++) {
            pages.push(i);
        }
        return pages;
    }

    // 수정 페이지로 이동
    public goToEdit(orgId: string) {
        this.service.href(`/admin/data/org/${orgId}`);
    }

    // ═══════════════════════════════════════════════════════
    // 편집 모드
    // ═══════════════════════════════════════════════════════
    public async loadOrgDetail(orgId: string) {
        this.editLoading = true;
        this.orgSaveError = '';
        this.orgSaveSuccess = false;
        await this.service.render();

        try {
            const json = await this.postForm('org_get', { org_id: orgId });
            if (json.code === 200 && json.data?.data) {
                const row = json.data.data;
                this.orgEdit = {
                    org_id: row?.org_id || '',
                    org_kor: row?.org_kor || '',
                    org_eng: row?.org_eng || '',
                    org_eng_abb: row?.org_eng_abb || '',
                    org_chn: row?.org_chn || '',
                    url: row?.url || '',
                    tel: row?.tel || '',
                    cntry: row?.cntry || '',
                    addr_kor: row?.addr_kor || '',
                    addr_eng: row?.addr_eng || '',
                    location_nm: row?.location_nm || '',
                    post_no: row?.post_no || '',
                    industry_cd: row?.industry_cd || '',
                    industry_nm: row?.industry_nm || '',
                    open_div: row?.open_div || '',
                    open_dt: row?.open_dt || '',
                    close_dt: row?.close_dt || '',
                    isni: row?.isni || '',
                    ror_id: row?.ror_id || '',
                    grid_id: row?.grid_id || '',
                    ringgold_id: row?.ringgold_id || '',
                    wiki_id: row?.wiki_id || '',
                    reprsnt_org_id: row?.reprsnt_org_id || '',
                    name_rep: row?.name_rep || '',
                    city_rep: row?.city_rep || '',
                    doi: row?.doi || '',
                    idntfr_cnt: row?.idntfr_cnt || 0,
                    created: row?.created || '',
                    updated: row?.updated || '',
                };
            } else {
                this.orgEdit = null;
                this.orgSaveError = json?.data?.message || '기관 정보를 불러올 수 없습니다.';
            }
        } catch (e: any) {
            this.orgEdit = null;
            this.orgSaveError = e?.message || String(e);
        }

        this.editLoading = false;
        await this.service.render();
    }

    public goToList() {
        this.service.href('/admin/data/org');
    }

    public async saveOrg() {
        if (!this.orgEdit?.org_id || this.orgSaving) return;
        if (!this.orgEdit.org_kor?.trim()) {
            this.orgSaveError = '기관명(국문)은 필수 입력 항목입니다.';
            await this.service.render();
            return;
        }
        this.orgSaving = true;
        this.orgSaveError = '';
        this.orgSaveSuccess = false;
        await this.service.render();

        try {
            const json = await this.postForm('org_update', this.orgEdit);
            if (json.code !== 200) {
                this.orgSaveError = json?.data?.message || '저장에 실패했습니다.';
            } else {
                this.orgSaveSuccess = true;
                if (this.successTimer) clearTimeout(this.successTimer);
                this.successTimer = setTimeout(async () => {
                    this.orgSaveSuccess = false;
                    await this.service.render();
                }, 3000);
                await this.loadOrgDetail(this.orgEdit.org_id);
            }
        } catch (e: any) {
            this.orgSaveError = e?.message || String(e);
        }

        this.orgSaving = false;
        await this.service.render();
    }

    // ═══════════════════════════════════════════════════════
    // 선택 삭제
    // ═══════════════════════════════════════════════════════
    public toggleSelect(orgId: string) {
        if (this.selectedOrgs.has(orgId)) {
            this.selectedOrgs.delete(orgId);
        } else {
            this.selectedOrgs.add(orgId);
        }
        this.service.render();
    }

    public toggleSelectAll() {
        if (this.selectedOrgs.size === this.orgRows.length && this.orgRows.length > 0) {
            this.selectedOrgs.clear();
        } else {
            this.selectedOrgs.clear();
            for (const r of this.orgRows) {
                this.selectedOrgs.add(r.org_id);
            }
        }
        this.service.render();
    }

    public isSelected(orgId: string): boolean {
        return this.selectedOrgs.has(orgId);
    }

    public get isAllSelected(): boolean {
        return this.orgRows.length > 0 && this.selectedOrgs.size === this.orgRows.length;
    }

    public async deleteSelected() {
        if (this.selectedOrgs.size === 0 || this.deleting) return;
        const count = this.selectedOrgs.size;
        if (!confirm(`선택한 ${count}건의 기관 데이터를 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.`)) return;

        this.deleting = true;
        await this.service.render();

        try {
            const ids = Array.from(this.selectedOrgs);
            const json = await this.postForm('org_delete', { org_ids: JSON.stringify(ids) });
            if (json.code === 200) {
                this.selectedOrgs.clear();
                await this.loadOrgList(this.orgPage);
            } else {
                alert(json?.data?.message || '삭제에 실패했습니다.');
            }
        } catch (e: any) {
            alert(e?.message || '삭제 중 오류가 발생했습니다.');
        }

        this.deleting = false;
        await this.service.render();
    }

    // ═══════════════════════════════════════════════════════
    // 유틸리티
    // ═══════════════════════════════════════════════════════
    public formatNumber(n: number): string {
        if (!n) return '0';
        return n.toLocaleString();
    }

    public displayValue(val: any): string {
        if (val === null || val === undefined || val === '') return '-';
        return String(val);
    }
}

export default PortalAdminOrgComponent;